/**
 * Content Backfill telemetry events.
 *
 * Touchpoint naming: {domain}-{page}-{item}-{action}
 * Domain: catalog
 * Page: content-backfill
 *
 * NOTE: This module provides typed event tracking stubs.
 * When @amzn/uxm-aws-ui-components-react is added to this package,
 * replace console.log calls with trackCustomEvent from UxM.
 */

export enum ContentBackfillTelemetryEvent {
  PAGE_VIEW = 'catalog-content-backfill-page-view',
  RUN_SELECTED = 'catalog-content-backfill-run-selected',
  FILTER_CHANGED = 'catalog-content-backfill-filter-changed',
  ITEM_SELECTED = 'catalog-content-backfill-item-selected',
  CATALOGICAL_LINK_CLICKED = 'catalog-content-backfill-catalogical-link-clicked'
}

interface TelemetryEventData {
  [key: string]: string | number | boolean | undefined;
}

/**
 * Track a content backfill telemetry event.
 * Stub implementation — replace with UxM trackCustomEvent when available.
 */
export const trackContentBackfillEvent = (event: ContentBackfillTelemetryEvent, data?: TelemetryEventData): void => {
  // TODO: Replace with @amzn/uxm-aws-ui-components-react trackCustomEvent
  // when the dependency is added to this package.
  if (process.env.NODE_ENV === 'development') {
    console.debug('[ContentBackfill Telemetry]', event, data);
  }
};
